<div class="card">
  <div class="card-header text-header">
    <span class="fa fa-list"></span> Impact Assessment Workflow
  </div>
  <div class="p-2">
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/impact-assessment/dashboard')"
          id="nav-impact-assessment-dashboard-tab" (click)="getTabText('Impact Assessment Dashboard')"
          [routerLink]="['/impact-assessment/dashboard/']" [routerLinkActive]="['active']">Impact Assessment
          Dashboard</a>
          <a class="nav-item nav-link" *ngIf="checkRoutePermission('/impact-assessment/dashboard2')"
          id="nav-impact-assessment-dashboard-tab" (click)="getTabText('Impact Assessment Dashboard')"
          [routerLink]="['/impact-assessment/dashboard2/']" [routerLinkActive]="['active']">Impact Assessment
          Dashboard 2</a>
        <a class="nav-item nav-link" id="nav-impact-assessment-tab"
          *ngIf="checkRoutePermission('/impact-assessment/summary')" (click)="getTabText('Impact Assessment')"
          [routerLink]="['/impact-assessment/summary/']" [routerLinkActive]="['active']">Assessments In Progress</a>
        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/impact-assessment/complete')"
          id="nav-complete-assessmeng-tab" (click)="getTabText('Complete')"
          [routerLink]="['/impact-assessment/complete/']" [routerLinkActive]="['active']">Complete Assessments</a>
        <div class="active-modal-wrapper">
          <a [ngClass]="impactService.detailTabActive ? 'active-modal' : 'inactive-modal'"
            [attr.class]="impactService.detailTabActive ? 'nav-item nav-link active' : 'nav-item nav-link'"
            id="nav-impact-assessment-details-tab">Assessment Details</a>
        </div>
      </div>
    </nav>
    <div class="card-body">
      <!-- <div class="tab-content"> -->
      <router-outlet></router-outlet>
      <!-- </div> -->
    </div>
  </div>
</div>